import { ChevronRight } from "lucide-react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { MenuItem } from "@/types/menu";
import { NavLink } from "./nav-link";

export function NavItem({ item }: { item: MenuItem }) {
  const hasSubItems = "subItems" in item;
  if (!hasSubItems) {
    return (
      <NavLink to={item.path}>
        {({ isActive }) => (
          <SidebarMenuButton tooltip={item.title} isActive={isActive} asChild>
            <div>
              {item.icon && <item.icon />}
              <span>{item.title}</span>
            </div>
          </SidebarMenuButton>
        )}
      </NavLink>
    );
  }

  return (
    <Collapsible
      asChild
      defaultOpen={location.pathname.startsWith(item.path)}
      className="group/collapsible"
    >
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          <SidebarMenuButton tooltip={item.title}>
            {item.icon && <item.icon />}
            <span>{item.title}</span>
            {hasSubItems && (
              <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
            )}
          </SidebarMenuButton>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <SidebarMenuSub>
            {item.subItems!.map((subItem) => (
              <SidebarMenuSubItem key={subItem.title}>
                <NavLink to={subItem.path}>
                  {({ isActive }) => (
                    <SidebarMenuSubButton isActive={isActive} asChild>
                      <span>{subItem.title}</span>
                    </SidebarMenuSubButton>
                  )}
                </NavLink>
              </SidebarMenuSubItem>
            ))}
          </SidebarMenuSub>
        </CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  );
}
